import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { CanvasProvider } from "./context/canvasContext";
import { BoardFileProvider } from "./context/boardFileContext";
import ResultComponent from './components/ResultComponent/ResultComponent';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { DocumentInfoProvider } from "./context/documentInfoContex";
import './utils/canvasInit';
import Dashboard from "./components/Dashboard";

ReactDOM.render(
  <React.StrictMode>
    <BoardFileProvider>
      <CanvasProvider>
        <DocumentInfoProvider>
          <Router>
            <Switch>
              <Route
                exact
                path="/"
              >
                <Dashboard />
              </Route>
              <Route
                path="/invalid-document" >
                <ResultComponent title="Document Verification Failed , Invalid Document. " />
              </Route>
              <Route
                path="/unauthorized">
                <ResultComponent title="Security Veification Failed , Unauthorized Access." subTitle="If you believe you should have access to this document please logout and login again. Incase the issues persists please contact the document owner." />
              </Route>
              <Route
                path="/no-internet"
              >
                <ResultComponent title="No Internet, Check your internet connection." />
              </Route>
              <Route
                exact
                path="/:id"
              >
                <App isExternal={false} />
              </Route>
              <Route
                exact
                path="/external/:id"
              >
                <App isExternal={true} />
              </Route>
            </Switch>
          </Router>
        </DocumentInfoProvider>
      </CanvasProvider>
    </BoardFileProvider>
  </React.StrictMode>,
  document.getElementById("root")
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
